

interface Resource{
    id:number,
    media:Media[],
    title: string
}

interface Media{
    branding: string,
    created: string,
    file_size: number,
    file_type: string,
    format: string,
    height: number,
    id: number,
    modified: string,
    reprint: number,
    resource_id: number,
    uri: string,
    version: number,
    width: number,

}

type ResourceImageProps = {
  resource:Resource,
  fallback?:string,
  priority:boolean
};
const ResourceImage = ({resource,fallback,priority}:ResourceImageProps) => {

    let {media,title,id} = resource;
    let mediaImages: Media[] = media.reduce((arr: Media[], curr) => {
        if(!curr.format.endsWith("a")){
            if(curr.format != 'original' && curr.width <= 800){
                arr.push(curr);
            }

        }
        return arr;
    },[]);
    mediaImages.sort((a,b) => {
        return a.width - b.width;
    })
    let img = mediaImages.find((med) => med.format === "w800");


    let firstImgSrc = img ? `${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${img?.uri}`: fallback ;

    if(!firstImgSrc) return null;

    return <picture key={id}>
        {mediaImages.map((m,index,array) => {

            let mediaQuery = `(max-width:${m.width}px)`;

            let imageType = `image/${m.file_type}`;
            if(m.file_type == 'jpg'){
                imageType = `image/jpeg`;
            }

            return <source key={m.id} srcSet={`${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${m.uri}`} media={mediaQuery} type={imageType}/>
        })}

        <img src={firstImgSrc} alt={title} style={{display:'block'}} loading={priority ? undefined : 'lazy'} fetchPriority={priority ? 'high' : undefined} height="100%" width="100%"/>
    </picture>;
};

export default ResourceImage;
